import React from 'react';
import Icon from '@mdi/react';
import * as mdiIcons from '@mdi/js';

interface RecordedMarkerSvgProps {
  iconName: string;
  backgroundColor: string;
  isHighlighted?: boolean;
}

/**
 * Recorded marker - circle with icon and triangle
 * Ported from ui/src/components/markers/RecordedMarkerSvg.tsx
 */
export const RecordedMarkerSvg: React.FC<RecordedMarkerSvgProps> = ({
  iconName,
  backgroundColor,
  isHighlighted = false,
}) => {
  const size = isHighlighted ? 40 : 30;
  const iconSize = isHighlighted ? 30 : 22;
  const svgSize = size + 10;

  // Convert kebab-case to camelCase and add mdi prefix
  const getMdiIconPath = (name: string): string => {
    const iconKey = 'mdi' + name.split('-').map(word =>
      word.charAt(0).toUpperCase() + word.slice(1)
    ).join('');
    return (mdiIcons as any)[iconKey] || mdiIcons.mdiHeadphones;
  };

  return (
    <div style={styles.markerContainer}>
      <div style={styles.markerInnerContainer}>
        <div style={styles.combinedContainer}>
          <svg width={svgSize} height={svgSize + 8} viewBox={`0 0 ${svgSize} ${svgSize + 8}`}>
            {/* White border - outer circle + triangle */}
            <circle cx={svgSize / 2} cy={size / 2} r={size / 2} fill="white" />
            <path
              d={`M ${svgSize / 2 + 8},${size - 3} L ${svgSize / 2},${size + 5} L ${svgSize / 2 - 8},${size - 3} Z`}
              fill="white"
            />

            {/* Colored fill - inner circle + triangle */}
            <circle cx={svgSize / 2} cy={size / 2} r={(size - 3) / 2} fill={backgroundColor} />
            <path
              d={`M ${svgSize / 2 + 6.5},${size - 3} L ${svgSize / 2},${size + 3} L ${svgSize / 2 - 6.5},${size - 3} Z`}
              fill={backgroundColor}
            />
          </svg>

          {/* Icon overlay */}
          <div style={{ ...styles.iconOverlay, top: size / 2 - iconSize / 2 }}>
            <Icon path={getMdiIconPath(iconName)} size={`${iconSize}px`} color="white" />
          </div>
        </div>
      </div>
    </div>
  );
};

const styles = {
  combinedContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative' as const,
  },
  iconOverlay: {
    position: 'absolute' as const,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  markerContainer: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: 'transparent',
    height: 55,
    justifyContent: 'center',
    width: 40,
  },
  markerInnerContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
};
